import { LockOutlined, SettingOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, type MenuProps } from 'antd';
import config from 'config';
import { useEffect, useState } from 'react';
import { useTranslation } from 'translations/hooks';
import { useNavigate } from 'react-router';
import { Routes } from 'business/router/constants';

import { useSession } from 'technical/auth/client';
import { LanguageSelector } from 'ui/language-selector';
import { getLocalStorageValue } from 'technical/local-storage';
import { SCAN_SITE_KEY } from 'technical/local-storage/constants';
import {
  scanSiteSchema,
  type ScanSiteSchema,
} from 'technical/local-storage/types';
import { SCAN_SITE_UPDATED } from 'technical/event/constants';

export const UserMenu = () => {
  const { t } = useTranslation();
  const { data: session } = useSession();
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [scanSite, setScanSite] = useState<ScanSiteSchema | null>(() =>
    getLocalStorageValue({ key: SCAN_SITE_KEY, schema: scanSiteSchema }),
  );

  useEffect(() => {
    const handleUpdate = () => {
      const updatedValue = getLocalStorageValue<ScanSiteSchema>({
        key: SCAN_SITE_KEY,
        schema: scanSiteSchema,
      });
      setScanSite(updatedValue);
    };

    window.addEventListener(SCAN_SITE_UPDATED, handleUpdate);

    return () => {
      window.removeEventListener(SCAN_SITE_UPDATED, handleUpdate);
    };
  }, []);

  const handleOpenChange = (flag: boolean) => {
    setIsDropdownOpen(flag);
  };

  const dropdownItems: MenuProps['items'] = [
    {
      key: 'language',
      label: (
        <div onClick={(e) => e.stopPropagation()}>
          <LanguageSelector />
        </div>
      ),
    },
    {
      key: 'username',
      disabled: true,
      label: session?.user.name,
    },
    {
      key: 'scanSite',
      disabled: true,
      label: scanSite?.label ?? '-',
    },
    {
      key: 'admin',
      label: t('header.admin'),
      icon: <LockOutlined />,
      onClick: () => {
        navigate(Routes.SessionInfo);
      },
    },
    {
      key: 'version',
      disabled: true,
      label: config.version,
    },
  ];

  return (
    <>
      <Dropdown
        menu={{ items: dropdownItems }}
        trigger={['click']}
        open={isDropdownOpen}
        onOpenChange={handleOpenChange}
      >
        <Avatar className="bg-primary cursor-pointer">
          <SettingOutlined />
        </Avatar>
      </Dropdown>
    </>
  );
};
